// extracted by mini-css-extract-plugin
export default {"overlay":"yB-z","bodyOpen":"zB-z","content":"AB-z","header":"BB-z","close":"CB-z","closeNoHeading":"DB-z"};